import { Button, Drawer, Image, message, Popconfirm, Skeleton } from 'antd';
import * as appRoutes from "config/routes.config";
import React, { Fragment, useEffect, useState } from 'react';

import AppResult from 'components/appResults';
import s from "./style.module.css";

//IMAGES
import { setIcon, StatusCode, UserRoles } from 'common/enums';
import StudentNavBar from 'components/StudentNavBar';
import { SponsorDrawerPaiement } from 'components/paiementSponsor';
import { useNavigate } from 'react-router-dom';
import ParentStudentCalendar from 'screens/student/studentCalendar';

import Ads from "assets/images/app/header/ads.svg";
import Calendar from "assets/images/app/header/calendar.svg";
import Performance from "assets/images/app/header/performance.svg";
import Wallet from "assets/images/app/header/wallet.svg";
import Remove from "assets/images/app/remove-user.png";

import * as AUTH_SERVICES from "api/services/auth/auth.services";
import SendUpdatePasswordRequestDrawer from 'components/updatePasswordDrawer/sendUpdateLink';
import Access from "../../assets/images/app/access.svg";
import Check from "../../assets/images/app/check.svg";
import Star from "../../assets/images/app/start.svg";

type Props = {
    userData: any;
    historyData: any;
    studentId: any;
    loading: boolean;
    user: any;
    sponsorData: any;
}

const ParentOrganismeStudentHistory: React.FC<Props> = ({ userData, historyData, studentId, loading, user, sponsorData }) => {

    const navigate = useNavigate();
    const isParent = user?.roles?.includes(UserRoles.PARENT);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const [isTablet, setIsTablet] = useState(window.innerWidth > 767 && window.innerWidth <= 1024);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
        setIsTablet(window.innerWidth > 767 && window.innerWidth <= 1024);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [calendarDrawerVisibility, setCalendarDrawerVisibility] = useState<boolean>(false);
    const closeCalendarDrawer = async () => {
        setCalendarDrawerVisibility(false);
    }

    const [walletDrawerVisibility, setWalletDrawerVisibility] = useState<boolean>(false);
    const closeWalletDrawer = async () => {
        setWalletDrawerVisibility(false);
    }

    const [passwordDrawerVisible, setPasswordDrawerVisible] = useState(false);
    const onClosePasswordDrawer = () => {
        setPasswordDrawerVisible(false);
    };

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [visibleDelete, setVisibleDelete] = useState<boolean>(false);

    const MENU = [
        {
            id: 1,
            name: "Accès",
            icon: Access,
            iconSize: 25,
            link: "",
        },
        {
            id: 2,
            name: "Historique",
            icon: Ads,
            iconSize: 35,
            link: `${appRoutes.STUDENT_HISTORY}/${studentId}`,
        },
        {
            id: 3,
            name: "Performance",
            icon: Performance,
            iconSize: 35,
            link: {
                pathname: `${appRoutes.STUDENT_STATISTIQUES}/${studentId}`,
                state: sponsorData,
            },
        },
        {
            id: 4,
            name: "Portefeuille",
            icon: Wallet,
            iconSize: 35,
            link: "",
        },
        {
            id: 5,
            name: "Calendrier",
            icon: Calendar,
            iconSize: 35,
            link: "",
        },
        {
            id: 6,
            name: "Retirer l'élève",
            icon: Remove,
            iconSize: 25,
            link: "",
        },
    ];

    const doAction = async (name: string) => {
        if (name === "Retirer l'élève") {
            setVisibleDelete(true)
        }
        else if (name === "Accès") {
            setPasswordDrawerVisible(true)
        }
        else if (name === "Calendrier") {
            setCalendarDrawerVisibility(true)
        }
        else if (name === "Portefeuille") {
            setWalletDrawerVisibility(true)
        }
        else if (name === "Performance") {
            isParent ? navigate(`${appRoutes.STUDENT_STATISTIQUES}/${studentId}`, { state: sponsorData }) : navigate(`${appRoutes.ORGANISM_STUDENT_STATISTIQUES}/${studentId}`, { state: sponsorData });
        }
        else { }
    }

    const dissociateStudent = async () => {
        setIsLoading(true);
        try {
            const response = await AUTH_SERVICES.dissociateStudent(user?._id, userData?._id);
            if (response?.statusCode === StatusCode.CREATED) {
                message.success({
                    content: "Élève retiré avec succès",
                });
                setIsLoading(false);
                setVisibleDelete(false);

                setTimeout(() => {
                    isParent ? navigate(appRoutes.PARENT_DASHBOARD) : navigate(appRoutes.ORGANISM_DASHBOARD);
                }, 1000);
            }
            else {
                message.warning({
                    content: "Ooops, Une erreur est survenue",
                });
                setIsLoading(false);
                setVisibleDelete(false);
            }
        } catch (error: any) {
            let content = "";
            for (
                let index = 0;
                index < error?.response?.data?.message?.length;
                index++
            ) {
                content = error?.response?.data?.message[index] + ", " + content;
            }
            message.error({
                content: content,
            });
        }
    }

    return (
        <>
            <div style={{
                display: "flex",
                flexDirection: "column",
                margin: "0px",
                padding: isMobile ? "0 10px" : "0px",
                position: "relative",
                top: isMobile ? "0" : "-30px"
            }}>
                <div style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    alignItems: isMobile ? "flex-start" : "center",
                    justifyContent: "space-between",
                    height: isMobile ? "auto" : "100px",
                    gap: isMobile ? "15px" : "0"
                }}>
                    {loading ? <Skeleton active /> : <StudentNavBar userData={userData} handleOpenPasswordDrawer={() => setPasswordDrawerVisible(true)} />}
                    <div style={{
                        display: isMobile ? "grid" : "flex",
                        flexDirection: isMobile ? undefined : "row",
                        gridTemplateColumns: isMobile ? "repeat(3, 1fr)" : undefined,
                        gap: isMobile ? "15px" : "0",
                        width: isMobile ? "100%" : "auto"
                    }}>
                        <>
                            {MENU.map((item) => (
                                <ul
                                    key={item.id}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: isMobile ? "0.9em" : "1.2em",
                                        fontWeight: "bolder",
                                        marginLeft: isMobile ? "0" : "10px",
                                        gap: "5px",
                                    }}
                                >
                                    <li>
                                        <Image
                                            preview={false}
                                            src={item.icon}
                                            width={isMobile ? (item?.iconSize || 29) * 0.7 : 29}
                                            onClick={() => doAction(item?.name)}
                                            style={{ cursor: "pointer", border: "1px solid #FAFAFA", borderRadius: "50%", background: "#FAFAFA" }}
                                            alt={item.name}
                                        />
                                    </li>
                                    <li style={{ textAlign: "center", width: "100%" }}>
                                        <span
                                            style={{
                                                fontWeight: item.name === "Historique" ? "500" : "normal",
                                                color: "#7FB1B2",
                                                cursor: "pointer",
                                                fontSize: isMobile ? "0.7em" : "1em",
                                                display: "block",
                                                whiteSpace: isMobile ? "nowrap" : "normal",
                                                overflow: isMobile ? "hidden" : "visible",
                                                textOverflow: isMobile ? "ellipsis" : "clip"
                                            }}
                                            onClick={() => doAction(item?.name)}
                                            title={item.name}
                                        >
                                            {item.name}
                                        </span>
                                    </li>
                                </ul>
                            ))}
                            <Popconfirm
                                title={`Voulez-vous bien retirer l'élève de votre ${isParent ? "compte" : "organisme"} ?`}
                                visible={visibleDelete}
                                onConfirm={dissociateStudent}
                                onCancel={() => setVisibleDelete(false)}
                                okText="Oui"
                                cancelText="Non"
                            >
                                <Button style={{ visibility: "hidden" }}></Button>
                            </Popconfirm>
                        </>
                    </div>
                </div>
                <div className={s.lineBox}>
                    {loading ? <Skeleton active /> : <div
                        style={{
                            width: "100%",
                            borderRadius: "10px",
                            background: "#fafafa",
                            marginTop: isMobile ? "10px" : "20px",
                            padding: isMobile ? "10px" : "0"
                        }}
                    >
                        {historyData.length > 0 ? (
                            <Fragment>
                                {historyData.map((historique: any, index: number) => (
                                    historique?.status === "SUCCESS" && <div key={index} style={{ marginBottom: isMobile ? "1em" : "2em" }} className={s.card}>
                                        <div style={{
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: isMobile ? "column" : "row",
                                            alignItems: isMobile ? "flex-start" : "center",
                                            justifyContent: "space-between",
                                            gap: isMobile ? "10px" : "0"
                                        }}>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: isMobile ? "column" : "row",
                                                alignItems: isMobile ? "flex-start" : "center",
                                                justifyContent: "center",
                                                fontSize: isMobile ? "0.9em" : "1.2em",
                                                gap: isMobile ? "8px" : "0"
                                            }}>
                                                <div>
                                                    <span style={{ color: "green", fontWeight: "600" }}>
                                                        <img src={Check} height={isMobile ? 12 : 15} style={{ marginRight: "5px" }} alt="check"></img>
                                                        {historique?.status === "SUCCESS" ? "Cours terminé" : "Cours prévu pour le"}
                                                    </span>
                                                    le {historique['date']}
                                                </div>
                                                <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    paddingLeft: "10px",
                                                    paddingRight: "10px",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                    background: "#D5D5D5",
                                                    marginLeft: isMobile ? "0" : "20px",
                                                    borderRadius: "8px",
                                                    alignItems: "center",
                                                    gap: "5px"
                                                }}>
                                                    <img src={setIcon(historique['topic'])} height={isMobile ? 20 : 30} alt={historique['topic']} />
                                                    <span style={{ position: "relative", top: "2px", fontSize: isMobile ? "0.85em" : "1em" }}>
                                                        {historique['topic']}
                                                    </span>
                                                </div>
                                            </div>
                                            {historique.teacherNoted && <div className={s.rateBox}>
                                                <div className={s.dashedBox}>
                                                    <span style={{ color: "#7FB1B2" }}>Cours</span>
                                                    <span className={s.rateBoxSpan}>
                                                        <img src={Star} height={10} className={s.rateBoxStar} alt="star"></img>
                                                        {historique?.teacherRating?.rateCours}
                                                    </span>
                                                </div>
                                                <div className={s.dashedBox}>
                                                    <span style={{ color: "#7FB1B2" }}>Application</span>
                                                    <span className={s.rateBoxSpan}>
                                                        <img src={Star} height={10} className={s.rateBoxStar} alt="star"></img>
                                                        {historique?.teacherRating?.rateApplication}
                                                    </span>
                                                </div>
                                                <div className={s.dashedBox}>
                                                    <span style={{ color: "#7FB1B2" }}>Exercice</span>
                                                    <span className={s.rateBoxSpan}>
                                                        <img src={Star} height={10} className={s.rateBoxStar} alt="star"></img>
                                                        {historique?.teacherRating?.rateExercice}
                                                    </span>
                                                </div>
                                            </div>}
                                        </div>

                                        {historique?.teacherRating?.comment !== "" && <div style={{
                                            fontSize: isMobile ? "0.9em" : "1.2em",
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "flex-start",
                                            justifyContent: "flex-start",
                                            marginTop: isMobile ? "5px" : "0"
                                        }}>
                                            {historique?.teacherRating?.comment}
                                        </div>}
                                    </div>
                                ))}
                            </Fragment>
                        ) : (
                            <AppResult status={"info"} title="Aucune séance" />
                        )}
                    </div>}
                </div>
            </div>
            <Drawer
                placement="right"
                closable={true}
                onClose={closeCalendarDrawer}
                visible={calendarDrawerVisibility}
                width={isMobile ? "100%" : isTablet ? "85%" : "85%"}
                headerStyle={{ display: "flex", justifyContent: "space-between" }}
                bodyStyle={{ background: "#FFF", padding: isMobile ? "10px" : "0px" }}
            >
                <div style={{ alignItems: "flex-start", margin: isMobile ? "20px auto" : "40px auto" }}>
                    <ParentStudentCalendar user={userData} />
                </div>
            </Drawer>
            <Drawer
                placement="right"
                closable={true}
                onClose={closeWalletDrawer}
                visible={walletDrawerVisibility}
                width={isMobile ? "100%" : isTablet ? "60%" : "40%"}
                headerStyle={{ display: "flex", justifyContent: "space-between" }}
                bodyStyle={{ background: "#FFF", padding: isMobile ? "10px" : "0px" }}
            >
                <div style={{ alignItems: "flex-start", margin: isMobile ? "20px auto" : "40px auto" }}>
                    <SponsorDrawerPaiement currentUser={userData} type="student" />
                </div>
            </Drawer>
            <SendUpdatePasswordRequestDrawer visible={passwordDrawerVisible} onClose={onClosePasswordDrawer} userData={userData} />
        </>
    );
};

export default ParentOrganismeStudentHistory;